var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"slot":"reference"},on:{"click":_vm.toalarm},slot:"reference"},[_c('el-badge',{attrs:{"value":_vm.dotval}},[_c('i',{staticClass:"el-icon-bell"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }